import { searchCommonConfig } from './common'

/**
 * Ficmoon 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#1F1E20',
    startReadingBg: 'linear-gradient(90deg, #FF6E0F 0%, #FF5970 100%)',
  },
}
